import { h, Component } from 'preact';
import { accessNested, joinClasses } from 'utils/utils';
import { getValueForClientSize } from 'utils/bolt';
import { useDynamicAssetFolder } from 'utils/assets';
import * as webp from 'utils/bolt/webp';
import s from 'components/bolt/sectionLoader/spinner.sss';

export default class Spinner extends Component {

	constructor(props) {
		super(props);
	}

	render(props, { ttLoaded }) {
		const { appData, onlySpinner, class: extraClass } = props;
		const copy = appData ? appData.copy : {};
		const accessibilityCopy = copy.accessibilityCopy || {};
		const tt = accessNested(this.props, 'appData.header.powsterHeader.tt', null);
		const fallbackFormat = accessNested(this.props, appData.header.alternativeImageFormat || 'png');

		return (
			<div class={joinClasses(extraClass, s.container, onlySpinner && s.centered)}>
				{
					!onlySpinner && (
						<webp.Picture
							style={{ display: ttLoaded ? 'block' : 'none' }}
							class={s.tt}
							key="tt"
							alt={accessibilityCopy}
							src={tt && useDynamicAssetFolder(getValueForClientSize(tt))}
							fallbackFormat={fallbackFormat}
							onLoad={() => this.setState({ ttLoaded: true })}
						/>
					)}
				<div class={s.ring} key="spinner" />
			</div>
		);
	}
}
